import { Injectable } from '@angular/core';
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot
} from '@angular/router';
import { of, Observable } from 'rxjs';
import { AuthService } from '../services/auth.service';

import { PublisherService } from '../services/publisher.service';
import { OktaAuthService } from '../services/okta-auth.service';
import { AppUtilService } from '../utils/app-util.service';
import { CacheConstant } from '../constants/app.constant';
import 'rxjs/add/operator/map';

@Injectable()
export class AuthGuard implements CanActivate {

  callBackURL: string;
  /***************Constructor***************/
  constructor(
    private oktaAuthService: OktaAuthService,
    private authService: AuthService
  ) { }
  /***************Constructor***************/

  /******************Implementation Methods******************/

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean | Observable<boolean> | Promise<boolean> {
    return this.oktaAuthService
      .getUserSession()
      .map((res: any) => {
        return this.validateSession(res, state);
      })
      .toPromise();
  }

  // Method to validate the user session
  private validateSession(res: any, state: any) {
    if (!res.hasError && res.expiresAt) {
      const expiryDate = new Date(res.expiresAt);
      const currentDate = new Date();
      const oktaAuthenticated = expiryDate > currentDate;
      const parmedAuthenticated = this.authService.isAuthenticated();

      if (oktaAuthenticated && parmedAuthenticated) {
        AppUtilService.cache.set(CacheConstant.Okta_Session_Id, res.id);
        AppUtilService.cache.set(CacheConstant.Okta_Authenticated, true);
        return true;
      }
    }

    AppUtilService.cache.set(CacheConstant.Okta_Session_Id, null);
    AppUtilService.cache.set(CacheConstant.Okta_Authenticated, false);

    PublisherService.notifySignOutRequest();
   
    if ((state.url.indexOf('/order/review') > -1) || (state.url.indexOf('/order/summary') > -1) || (state.url.indexOf('/dscsa-transaction-data') > -1)) {
      this.callBackURL = '/myhome'
    }
    else {
      this.callBackURL = state.url;
    }
    PublisherService.notifySignInRequest({ isSessionTimeout: true, callBackUrl: this.callBackURL });
    return false;
  }

  /******************Implementation Methods******************/
}
